import { render, staticRenderFns } from "./BonusSmallIcon.vue?vue&type=template&id=0bb5c3fd&"
import script from "./BonusSmallIcon.vue?vue&type=script&lang=ts&"
export * from "./BonusSmallIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports